import { languageMap } from ".."

languageMap.editorconfig = {
	comments: {
		line: "#",
	},
}
